import { ModalInteraction } from './ModalInteraction'
import { ToastInteraction } from './ToastInteraction'

export const InteractionComponents = () => {
  return (
    <>
      <ToastInteraction />
      <ModalInteraction />
    </>
  )
}
